import React from 'react';
import styled from 'styled-components';

const SignWrap = styled.span<{
  $isAddition: boolean;
  $topOffset?: number;
  $marginRight?: number;
}>`
  color: ${({ $isAddition }) =>
    $isAddition ? 'var(--green4)' : 'var(--red3)'};
  font-size: 20px;
  line-height: 0;
  position: relative;
  ${({ $topOffset }) => $topOffset !== undefined && `top: ${$topOffset}px;`};
  ${({ $marginRight }) =>
    $marginRight !== undefined && `margin-right: ${$marginRight}px;`};
`;

interface Props {
  type: 'deposit' | 'withdrawal';
  topOffset?: number; // optional
  marginRight?: number; // optional
}

export default function VaultBalanceEventSign({
  type,
  topOffset,
  marginRight,
}: Props) {
  return (
    <SignWrap
      $isAddition={type === 'deposit'}
      $topOffset={topOffset}
      $marginRight={marginRight}
    >
      {type === 'deposit' ? '+' : '–'}
    </SignWrap>
  );
}
